import {
  CALCULATION_BEGINS,
  CALCULATION_ENDS,
  REGISTER,
} from "./constants/constants";

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export const trackPageView = (url: string) => {
  const pageEvent = {
    event: "pageview",
    page: url,
  };

  window?.dataLayer?.push?.(pageEvent);

  return pageEvent;
};

const trackEvent = (eventParam: { event: string } | string) => {
  const event =
    typeof eventParam === "object"
      ? eventParam
      : {
          event: eventParam,
        };

  window?.dataLayer?.push?.(event);

  return event;
};

export const trackRegister = () => trackEvent(REGISTER);

export const trackCalculationBegins = () => trackEvent(CALCULATION_BEGINS);

export const trackCalculationEnds = () => trackEvent(CALCULATION_ENDS);
